module.exports = "/images/Simplo7.png?4e60f012faf89e5dc9561c39e1f7f7dd";